export class TblWhatsAppTemplate
{
    refNo:number
    templateId:string;
    templateName:string;
    templateDetails:string;
    active:string;
    fileAllowed:string;
}